import React from 'react';
import { Outlet } from 'react-router-dom';
import { FaLock, FaUserMd, FaChartLine, FaSearch } from 'react-icons/fa';
import styles from './AuthLayout.module.css';
import { AuthLayoutProps } from './types';
import useAuthLayout from './useAuthLayout';
import logo from '../../asset/logo.png';
import prImage from '../../asset/PR.png';

/**
 * 認証関連ページ（ログイン・サインアップなど）の共通レイアウトコンポーネント
 * 左パネルにブランディング情報、右パネルにフォームを配置
 * 
 * @returns {JSX.Element} AuthLayoutコンポーネント
 */
const AuthLayout: React.FC<AuthLayoutProps> = () => {
  // カスタムフックを使用してbodyクラスの設定と副作用を管理
  useAuthLayout();

  return (
    <div className={styles['auth-layout-container']} data-testid="auth-layout">
      <div className={styles['auth-layout-left-panel']}>
        <img
          src={prImage}
          alt="Med Tube PR"
          className={styles['auth-layout-background-image']}
        />
        <div className={styles['auth-layout-content-wrapper']}>
          <p className={styles['auth-layout-description']}>
            <span className={styles['auth-layout-highlight']}>手術映像</span>を
          </p>
          <p className={styles['auth-layout-description']}>
            いつでもどこでも
          </p>
          <p className={styles['auth-layout-description-english']}>
            MEDICAL VIDEO PLATFORM
          </p>
        </div>
      </div>
      <div className={styles['auth-layout-form-panel']}>
        <img src={logo} alt="Med Tube" className={styles['auth-layout-logo']} />
        <Outlet /> {/* 各ページ（ログインやサインアップ）がここに表示される */}
      </div>
    </div>
  );
};

export default AuthLayout; 